export default __webpack_public_path__ + "static/media/webScrape.c751dfc1.PNG";